export const CF_TURNSTILE_SITEKEY_STAGING = '0x4AAAAAAAPd8TmUM7-dvTKb';

export const CF_TURNSTILE_SITEKEY_PRODUCTION = '0x4AAAAAAB8OmCVoASWUCnbW';

export const GTM_ID = 'GTM-K5FWXG4';

export const GTM_CLIENT_TYPE = 'WEB_APP';

export const GTM_AUTH_STAGING = 'obU596jZkQ8pXq1df8v0OA';

export const GTM_AUTH_PRODUCTION = 'JhTkGQKxflcbelVyldTavg';

export const GTM_PREVIEW_STAGING = 'env-5';

export const GTM_PREVIEW_PRODUCTION = 'env-2';

export const CAR_RENTAL_SEARCH_FORM_KEY = 'CAR_RENTAL_SEARCH_FORM';

export const MEILI_PTID = '143.10'; // This id will be used to design Widget according to our design theme

export const CAR_RENTAL_ALLOWED_LOCALES = ['en', 'ar'];

export const CAR_RENTAL_PATH_NAME = 'car-rentals';
